module.exports = __webpack_public_path__ + "static/media/img012.943bcc6c.jpg";